export default {
	text: {
		recordSetsTitle: 'Rekordliste',
		newRecordSetTitle: 'Neue Rekordliste',
		updateRecordSetTitle: 'Rekordliste bearbeiten',
		recordsTitle: 'Rekorde',
		newRecordTitle: 'Neuer Rekord',
		updateRecordTitle: 'Rekord bearbeiten',
		recordSetsLoading: 'Rekordlisten werden geladen',
		newRecordSet: 'Neue Rekordliste',
		newRecord: 'Neuer Rekord',
		headerRecordSetName: 'Name',
		recordCode: 'Code',
		recordTypeLable: 'Rekord-Type',
		recordType: {
			record: 'Rekord',
			limit: 'Limit',
			annualBest: 'Jahresbestleistung',
			other: 'Anderes',
		},
		recordValidityLable: 'Reichweite',
		recordValidity: {
			world: 'Weltrekord',
			olympic: 'Olympiarekord',
			continent: 'Kontinentalrekord',
			national: 'Nationalrekord',
			region: 'Regionalrekord',
			district: 'Bezirksrekord',
			area: 'Kreisrekord',
			club: 'Vereinsrekord',
			event: 'Veranstaltungsrekord',
			stadion: 'Stadionrekord',
			meeting: 'Meetingrekord',
		},
		recordStateLable: 'Rekordstatus',
		recordState: {
			official: 'Offiziell',
			inofficial: 'Inoffiziell',
		},
		validityQualifierLable: 'Reichweite für',
	},
};
